import React from "react";
import "../../assets/css/side-nav.css";
import "../../assets/css/common.css";

import logo from "../../assets/icons/Logo.svg";
import menuIcon from "../../assets/icons/ic-round-menu.svg";
import employerIcon from "../../assets/icons/Group 27659.svg";
import candidateIcon from "../../assets/icons/Group 27660.svg";
import { Link, useLocation } from "react-router-dom";
import { AiOutlineLogout } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { logOut } from "../../features/auth/authSlice";
import { RiArrowLeftSLine } from "react-icons/ri";
import { SUPER_ADMIN } from "../../constant";

export default function SideNav({
  isCollapse,
  setIsCollapse,
  isMobileNav,
  setIsMobileNav,
}) {
  const location = useLocation();
  const dispatch = useDispatch();
  const handleLogout = async () => {
    dispatch(logOut());
  };

  const auth = useSelector((state) => state.auth);
  console.log("auth", auth);

  const queryString = "?page=1&limit=10";

  const handleCollapse = () => {
    setIsCollapse(!isCollapse);
  };

  return (
    <nav className={`side_navigation_container ${isMobileNav ? "acitve" : ""}`}>
      <div className="left_top_header">
        <img
          src={menuIcon}
          alt=""
          className="MenuIcon"
          onClick={handleCollapse}
        />
        {isMobileNav && (
          <RiArrowLeftSLine
            color="white"
            size={35}
            onClick={() => setIsMobileNav(!isMobileNav)}
          />
        )}{" "}
        <img
          src={logo}
          alt="logo"
          className={isCollapse ? "collapse-logo" : "logo"}
        />
      </div>
      <Link
        className={`NavigationItem ${isCollapse ? "isCollapse" : ""} ${
          location.pathname === "/manage-employer" ? "navActive" : ""
        }`}
        to={"/manage-employer" + queryString}
        onClick={() => {
          setIsMobileNav(false);
        }}
      >
        <img src={employerIcon} alt="" />
        {!isCollapse && <div className="navTitle">Manage Employer</div>}
      </Link>
      <Link
        className={`NavigationItem ${isCollapse ? "isCollapse" : ""} ${
          location.pathname === "/manage-candidates" + queryString
            ? "navActive"
            : ""
        }`}
        to={"/manage-candidates" + queryString}
        onClick={() => {
          setIsMobileNav(false);
        }}
      >
        <img src={candidateIcon} alt="" />
        {!isCollapse && <div className="navTitle">Manage Candidates</div>}
      </Link>
      {auth?.userRole?.RoleCode == SUPER_ADMIN && (
        <Link
          className={`NavigationItem ${isCollapse ? "isCollapse" : ""} ${
            location.pathname === "/manage-LandingPages" ? "navActive" : ""
          }`}
          to={"/manage-LandingPages"}
          onClick={() => {
            setIsMobileNav(false);
          }}
        >
          <img src={candidateIcon} alt="" />
          {!isCollapse && <div className="navTitle">Manage PTMs</div>}
        </Link>
      )}

      <div
        className={`NavigationItem NavigationItemLogout ${
          isCollapse ? "isCollapse" : ""
        } `}
        onClick={handleLogout}
      >
        <AiOutlineLogout size={22} color="#7e7e7e" />
        {!isCollapse && <div className="navTitle"> Logout</div>}
      </div>
      {!isCollapse && (
        <div className={"copy-rigths-main"}>
          <span className="copy-rights-content">© 2024 SkillGigs</span>
          <span className={"version"}>version 1.0</span>
        </div>
      )}
    </nav>
  );
}
